import type { FunctionComponent, HTMLAttributes, PropsWithChildren, ReactHTML } from "react"

import classNames from "classnames"

import styles from "./Layout.module.css"

type LayoutProps = PropsWithChildren<{
  as?: keyof ReactHTML
  className?: string
  variant?: "4cols" | "3cols"
}> &
  HTMLAttributes<HTMLElement>

export const Layout: FunctionComponent<LayoutProps> = ({
  as: LayoutComponent = "div",
  children,
  className,
  variant,
  ...props
}) => {
  return (
    <LayoutComponent
      {...props}
      className={classNames(styles.layout, className, {
        [styles.variant_4cols]: variant === "4cols",
        [styles.variant_3cols]: variant === "3cols",
      })}
    >
      {children}
    </LayoutComponent>
  )
}
